import React, { useState, useEffect, useRef } from "react";
import { serverUrl } from "../../utils/constants";
import AboutUs from "../AboutUs/AboutUs";
import HeroSection from "../../compnents/Hero/Hero";
import Navbar from "../../compnents/Navbar/Navbar";
import Services from "../Service/Services";
import Footer from "../../compnents/footer/Footer";
import Maps from "../maps/Maps";
import UserSlip from "../UserSlip/UserSlip";
import { Box, Fade } from "@mui/material";
import { Campaign } from "@mui/icons-material";
import axios from "axios";

// Promotional Messages Array
const promotionalMessages = [
  "📦 Fast & Reliable Delivery Services – Trust RCS Express! 🚚",
  "🌟 Your Package, Our Priority – Delivering Excellence! ⭐",
  "⚡ Swift Shipping Solutions Across Pakistan! 🇵🇰",
  "🏆 Award-Winning Courier Service – Experience the Difference! 🎯",
  "🌍 International Shipping Made Simple & Secure! ✈️",
  "⏰ 24/7 Customer Support – We're Always Here for You! 💬",
  "📱 Track Your Package in Real-Time with RCS Express! 🛰️",
  "🎯 Nationwide Coverage – We Deliver Everywhere! 🗺️",
  "🔒 100% Safe & Secure Deliveries Guaranteed! ✅",
  "🚀 Express Delivery When You Need It Most! ⚡",
  "💼 Business Solutions Tailored to Your Needs! 📊",
  "🏃 Quick Pickup Service – We Come to You! 🚗",
  "💎 Premium Service at Competitive Prices! 💰",
  "🎊 Celebrating Over a Decade of Excellence! 🙏",
  "📦 Same Day Delivery Available – Order Today! 🕐",
  "🌈 Professional Courier Services You Can Trust! 🤝",
  "💳 Flexible Payment Options Available! 💵",
  "🎁 Gift Delivery Services – Send with Love! 💝",
  "🌟 Premium Packaging for Fragile Items! 📦",
  "💪 Handling Your Shipments with Care! ❤️",
  "🚚 Door-to-Door Service – Ultimate Convenience! 🏠",
  "📍 GPS Tracking for Complete Peace of Mind! 🛡️",
  "⭐ Thousands of Satisfied Customers Nationwide! 😊",
  "🎯 Your Trusted Logistics Partner! 🤝",
  "🌟 Quality Service, Every Single Time! ✨",
  "📦 Air & Sea Freight Services Available! 🌊",
  "💼 Corporate Solutions for Growing Businesses! 📈",
  "🏅 Industry-Leading Customer Satisfaction! 👥",
  "🚀 Innovation in Every Delivery! 💡",
  "🌍 Connecting Pakistan to the World! 🌐"
];

function Home() {
  const [Shipper, setShipper] = useState(null);
  const [showContent, setShowContent] = useState(false);
  const [currentMessage, setCurrentMessage] = useState("");
  const [messageAnimation, setMessageAnimation] = useState(false);
  const resultsRef = useRef(null);

  useEffect(() => {
    if (Shipper && resultsRef.current) {
      resultsRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  }, [Shipper]);

  const onChangeShipperState = (shipperData) => {
    setShipper(shipperData);
  };

  useEffect(() => {
    // Smooth scroll behavior
    document.documentElement.style.scrollBehavior = "smooth";

    // Fade in content
    setShowContent(true);

    // Select random message on page load
    const randomIndex = Math.floor(Math.random() * promotionalMessages.length);
    setCurrentMessage(promotionalMessages[randomIndex]);

    // Trigger animation
    setTimeout(() => setMessageAnimation(true), 100);

    const token = localStorage.getItem("token");
    axios
      .get(`${serverUrl}/loginadmin`, {
        headers: {
          Authorization: token,
        },
      })
      .then((res) => {
        if (res.status === 200) {
        }
      })
      .catch((err) => { });

    return () => {
      document.documentElement.style.scrollBehavior = "auto";
    };
  }, []);

  return (
    <Box
      sx={{
        background: "linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)",
        minHeight: "100vh",
      }}
    >
      <Navbar />

      {/* Modern Announcement Banner */}
      <Box
        sx={{
          background: "linear-gradient(135deg, #03A9F4 0%, #0277BD 100%)",
          padding: "14px 0",
          position: "relative",
          overflow: "hidden",
          boxShadow: "0 4px 20px rgba(2, 119, 189, 0.3)",
          "&::before": {
            content: '""',
            position: "absolute",
            top: 0,
            left: "-100%",
            width: "100%",
            height: "100%",
            background: "linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.3), transparent)",
            animation: "shimmer 3s infinite",
          },
          "&::after": {
            content: '""',
            position: "absolute",
            bottom: 0,
            left: 0,
            right: 0,
            height: "2px",
            background: "linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.5), transparent)",
            animation: "pulseGlow 2s ease-in-out infinite",
          }
        }}
      >
        <Fade in={messageAnimation} timeout={800}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "12px",
              animation: messageAnimation ? "bounceIn 0.8s ease-out" : "none",
            }}
          >
            <Campaign
              sx={{
                color: "white",
                fontSize: "28px",
                animation: "rotate 3s linear infinite",
              }}
            />
            <Box
              sx={{
                color: "white",
                fontFamily: "Montserrat",
                fontSize: { xs: "13px", md: "17px" },
                fontWeight: 700,
                letterSpacing: "0.5px",
                textAlign: "center",
                textShadow: "2px 2px 4px rgba(0, 0, 0, 0.2)",
                padding: "0 20px",
                animation: "fadeInScale 0.6s ease-out",
              }}
            >
              {currentMessage}
            </Box>
          </Box>
        </Fade>
      </Box>

      {/* Add keyframes for animations */}
      <style>
        {`
          @keyframes bounceIn {
            0% {
              opacity: 0;
              transform: scale(0.3) translateY(-20px);
            }
            50% {
              transform: scale(1.05) translateY(0);
            }
            70% {
              transform: scale(0.9);
            }
            100% {
              opacity: 1;
              transform: scale(1);
            }
          }

          @keyframes fadeInScale {
            0% {
              opacity: 0;
              transform: scale(0.8);
            }
            100% {
              opacity: 1;
              transform: scale(1);
            }
          }

          @keyframes rotate {
            0%, 100% {
              transform: rotate(0deg);
            }
            25% {
              transform: rotate(-15deg);
            }
            75% {
              transform: rotate(15deg);
            }
          }

          @keyframes pulseGlow {
            0%, 100% {
              opacity: 0.5;
              transform: scaleX(0.8);
            }
            50% {
              opacity: 1;
              transform: scaleX(1);
            }
          }
        `}
      </style>

      <Fade in={showContent} timeout={800}>
        <Box>
          <HeroSection onChangeShipperState={onChangeShipperState} />

          {Shipper !== null && (
            <Box ref={resultsRef} className="fade-in-up">
              <UserSlip shipperData={Shipper} />
            </Box>
          )}

          <Box className="fade-in">
            <Services />
          </Box>

          <Box className="fade-in">
            <AboutUs />
          </Box>

          <Box className="fade-in">
            <Maps />
          </Box>

          <Footer />
        </Box>
      </Fade>

      {/* Scroll to Top Button */}
      <Box
        onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
        sx={{
          position: "fixed",
          bottom: "30px",
          right: "30px",
          width: "56px",
          height: "56px",
          borderRadius: "8px",
          background: "linear-gradient(135deg, #03A9F4 0%, #0277BD 100%)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          cursor: "pointer",
          boxShadow: "0 8px 24px rgba(2, 119, 189, 0.4)",
          transition: "all 0.3s ease",
          zIndex: 1000,
          "&:hover": {
            transform: "translateY(-5px)",
            boxShadow: "0 12px 32px rgba(2, 93, 158, 0.6)",
          },
          "&::after": {
            content: '"↑"',
            color: "white",
            fontSize: "28px",
            fontWeight: "bold",
          }
        }}
      />
    </Box>
  );
}

export default Home;
